
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.677 39.128l-.878-3.873h7.737l1.023 3.873h-7.882zm-19.448 0l6.09-26.838h5.217l6.09 26.838H14.23zm-9.931 0l1.022-3.873h7.737l-.878 3.873H4.298zm4.462-9.744h5.629l-.878 3.871H7.928l.832-3.871zm3.277-5.871h3.685l-.88 3.871h-3.457l.652-3.871zm3.039-5.872h1.978l-.88 3.871H14.59l.486-3.871zm2.233-5.872h1.077l-.878 3.872h-.561l.362-3.872zm3.117-1.999h5.004V5h-5.004v4.77zm8.484 5.871h-.562l-.878-3.872h1.078l.362 3.872zm.77 5.871l-.878-3.871h1.979l.486 3.871H29.68zm4.792 5.872h-3.46l-.878-3.871h3.685l.653 3.871zm3.457 5.871h-5.584l-.88-3.871h5.633l.832 3.871zm5.894 6.617a1.001 1.001 0 01-.966 1.256H3a1.001 1.001 0 01-.967-1.256l1.549-5.871c.116-.439.513-.746.967-.746h1.333l1.093-5.08a1 1 0 01.977-.791h1.405l.848-5.038a1 1 0 01.987-.834h1.382l.627-4.996a1 1 0 01.993-.875h.743l.466-4.965a1 1 0 01.996-.907h2.027V4a1 1 0 011-1h7.004a1 1 0 011 1v5.769h2.028a1 1 0 01.996.907l.466 4.965h.743a1 1 0 01.993.875l.625 4.996h1.383a1 1 0 01.987.834l.849 5.038h1.405a1 1 0 01.977.791l1.092 5.08h1.334c.454 0 .85.307.967.746l1.548 5.871zm-27.104-5.853a.5.5 0 00.5.5h11.419a.5.5 0 000-1h-11.42a.5.5 0 00-.5.5zm1.75-5.754a.5.5 0 00.5.5h7.918a.5.5 0 100-1H18.97a.5.5 0 00-.5.5zm.992-5.812a.5.5 0 00.5.5h5.934a.5.5 0 100-1h-5.934a.5.5 0 00-.5.5zm1.7-5.312h3.534a.5.5 0 100-1h-3.534a.5.5 0 000 1z","fill":"#1D1D1B","fill-rule":"evenodd"}})])
          )
        }
      }
    